export default {
  en: {
    bannerImg: 'en.png',
    umText: 'Available Soon',
    requiredLogin: 'This game required to login',
    jackpotId_1: {
      name: 'Mythical Treasure Jackpot',
      level1Jackpot: 'GRAND',
      level2Jackpot: 'MEGA',
      level3Jackpot: 'MAJOR'
    },
    jackpotId_2: {
      name: 'Fluffy Jackpot',
      level1Jackpot: 'MEGA',
      level2Jackpot: 'MAXI',
      level3Jackpot: 'MINI'
    },
    jackpotId_3: {
      name: 'Golden Riches Jackpot',
      level1Jackpot: 'GRAND',
      level2Jackpot: 'MAJOR',
      level3Jackpot: 'MINOR',
      level4Jackpot: 'MINI',
    }
  },
};
